import React from 'react'
import { Form } from 'react-bootstrap'
import useItems from '../../../hooks/use-hours'

const LabelItem = ({
    placeholder,
    value = '',
    onChange =() => {},
    disabled,
    size
}) => {
    const [ items ] = useItems()
    if (!items) {
        return null
    }
    return (
        <Form.Control
            as='select' value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder} disabled={disabled}
            size={size}
        >
            <option value=''>{placeholder}</option>
            {items.map((item, k) => (<option value={item.id} key={k}>{item.name}</option>))}
        </Form.Control>
    )
}

export default LabelItem